import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { getDoc } from "../../../../API/DocList";
import { getDocPlan } from "../../../../API/DocListPlans";
import { getModel } from "../../../../API/ModelList";
import NavBar from "../../../Navbar/Navbar";
import { useTranslation } from "react-i18next";
import Ariane from "../../../Utils/Ariane";
import DocStat from "../LotStat/DocStats";
import Plan01Actions from "./Plan01Actions";
import DocsTableComponent from "./DocsTableComponent";
import FullDocTableConfig from "../../FullTableDocConfig.json";

const TabDoc = () => {
  const [data, setData] = useState([]);
  const [modelName, setModelName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [filter, setFilter] = useState({});
  const [modelInstanceStatuses, setModelInstanceStatuses] = useState([]);

  const { t } = useTranslation();

  // Cookies
  const instanceId = Cookies.get("instanceId");
  const instanceName = Cookies.get("instanceName");
  const modelId = Cookies.get("modelId");
  const clientId = Cookies.get("clientId");
  const instanceStatus = Cookies.get("instanceStatus");
  const configkeyset = Cookies.get("configkey");

  // Récupération des données
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const idToken = Cookies.get("Token");
        const modelData = await getModel(idToken);
        const modelIdFromCookie = Cookies.get("modelId");

        const matchedModel = modelData.find(
          (model) => model.ModelId === modelIdFromCookie,
        );
        if (matchedModel) {
          const modelComponent =
            matchedModel.ModelComponent || matchedModel.ModelName;
          const modelNameFormatted =
            modelComponent.charAt(0).toUpperCase() + modelComponent.slice(1);
          setModelName(modelNameFormatted);
          setModelInstanceStatuses(matchedModel.ModelDocumentStatus || []);

          let responseData;
          if (modelNameFormatted === "Plan01") {
            responseData = await getDocPlan(idToken, instanceId);
          } else {
            responseData = await getDoc(idToken, instanceId);
          }
          setData(responseData);
        }
      } catch (error) {
        console.error("Erreur lors du chargement des données", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const isInstanceEditable = (status) => {
    const notEditable = ["completed", "production"];
    return !notEditable.includes(status);
  };

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
      <NavBar />
      <div className="Ariane_LotStat_style">
        <Ariane
          mode="detailed"
          ModelName={modelName}
          instanceName={instanceName}
          instanceId={instanceId}
          handleCopy={(id) => console.log("Copié :", id)}
        />
        <DocStat
          lots={data}
          onFilterClick={(status) => {
            setFilter((prev) => {
              const newFilter = { ...prev, Status: status };
              return newFilter;
            });
          }}
        />
      </div>

      {modelName === "Plan01" && (
        <Plan01Actions
          data={data}
          filter={{}}
          instanceId={instanceId}
          modelId={modelId}
          selectedDocuments={selectedDocuments}
          setSelectedDocuments={setSelectedDocuments}
          configkeyset={configkeyset}
          instanceStatus={instanceStatus}
          t={t}
          isInstanceEditable={isInstanceEditable}
        />
      )}

      <DocsTableComponent
        data={data}
        setData={setData}
        modelName={modelName}
        modelId={modelId}
        clientId={clientId}
        instanceId={instanceId}
        page="TabDoc"
        tableConfig={FullDocTableConfig}
        selectedDocuments={selectedDocuments}
        modelInstanceStatuses={modelInstanceStatuses}
        setSelectedDocuments={setSelectedDocuments}
        filter={filter}
        setFilter={setFilter}
      />
    </>
  );
};

export default TabDoc;
